<div class="p-10" *ngIf="selectionService.dataSource.data.length === 0 && !selectionService.isLoading">
  <p>No se encontraron registros</p>
</div>

<div class="p-10 flex-expandir" *ngIf="selectionService.dataSource.data.length > 0 && !selectionService.isLoading">
  <div class="inner-card p-b-10 ">
    <div class="table-header-row">

      <mat-paginator [pageIndex]="selectionService.paginationProps.pageIndex"
        [length]="selectionService.paginationProps.length" [pageSize]="selectionService.paginationProps.pageSize"
        [pageSizeOptions]="[10, 50, 100]" (page)="getEmployees($event)">
      </mat-paginator>
  
      <button mat-icon-button [matMenuTriggerFor]="tableColumnMenu" class="except table-toggle-button">
        <mat-icon class="except">table_chart</mat-icon>
      </button>
  
      <mat-menu #tableColumnMenu="matMenu" class="except">
        <button class="except" mat-menu-item (click)="TraspasarEmployee()">
          <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
            transfer_within_a_station </mat-icon>Traspasar
        </button>
        <mat-divider></mat-divider>
        <div class="table-column-toggle-menu" (click)="$event.stopPropagation();">
          <mat-checkbox *ngFor="let cd of displayedColumns | listFilter: 'ISPERMIT': true; let i = index"
            (change)="toggleDisplayColumn(cd.column, $event.checked)" [checked]="cd.show" [hidden]="cd.disabled">
            {{cd.name}}</mat-checkbox>
        </div>
      </mat-menu>
    </div>
    <div class="list-tbl-view scroll-selection flex-expandir">
      <table mat-table [dataSource]="selectionService.dataSource" class="mat-elevation-z8 " #employeeSelection
        id="selection-employee" class="trabajador-selction">
        <caption></caption>
  
        <ng-container matColumnDef="action" class="except">
          <th id="actions" mat-header-cell *matHeaderCellDef> </th>
          <td mat-cell *matCellDef="let emp" class="except">
  
            <button *ngIf="emp.bloq === null" aria-haspopup="true"
              class="navbar-toggle-button mat-icon-button icn-person except"
              (click)="selectionService.GoToEmployee(emp.trabajadorId)">
              <span class="mat-button-wrapper except">
                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                  person </mat-icon>
              </span>
              <div class="mat-button-ripple mat-ripple mat-button-ripple-round except" matripple=""
                ng-reflect-centered="true">
              </div>
              <div class="mat-button-focus-overlay except"></div>
            </button>
  
            <button
              *ngIf="selectionService.selectionPermissions.HasUnlock || selectionService.selectionPermissions.HasDelete"
              mat-icon-button [matMenuTriggerFor]="appMenu" class="except">
              <mat-icon class="except">more_vert</mat-icon>
            </button>
  
            <mat-menu #appMenu="matMenu" class="except">
              <button class="except" mat-menu-item (click)="UnlockEmployee(emp)"
                *ngIf="selectionService.selectionPermissions.HasUnlock && emp.importacionId < 0">
                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                  lock_open </mat-icon>Desbloquear
              </button>
              <button class="except" mat-menu-item (click)="DeleteEmployee(emp)"
                *ngIf="selectionService.selectionPermissions.HasDelete">
                <mat-icon class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
                  delete </mat-icon>Eliminar
              </button>
            </mat-menu>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="empresa">
          <th id="empresa" mat-header-cell *matHeaderCellDef> Empresa </th>
          <td mat-cell *matCellDef="let emp"> {{emp.empresa | titlecase}} </td>
        </ng-container>
  
        <ng-container matColumnDef="referencia">
          <th id="referencia" mat-header-cell *matHeaderCellDef> Referencia </th>
          <td mat-cell *matCellDef="let emp"> {{emp.referencia | titlecase}} </td>
        </ng-container>
  
        <ng-container matColumnDef="provincia">
          <th id="provincia" mat-header-cell *matHeaderCellDef> Provincia </th>
          <td mat-cell *matCellDef="let emp"> {{emp.provincia | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="poblacion">
          <th id="poblacion" mat-header-cell *matHeaderCellDef> Población </th>
          <td mat-cell *matCellDef="let emp"> {{emp.poblacion | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="cp">
          <th id="cp" mat-header-cell *matHeaderCellDef> CP </th>
          <td mat-cell *matCellDef="let emp"> {{emp.cp | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="nif">
          <th id="nif" mat-header-cell *matHeaderCellDef> NIF </th>
          <td mat-cell *matCellDef="let emp"> {{emp.nif | titlecase}} </td>
        </ng-container>
  
        <ng-container matColumnDef="bloq">
          <th id="bloq" mat-header-cell *matHeaderCellDef> Bloq </th>
          <td mat-cell *matCellDef="let emp"> 
            <span *ngIf="emp.bloq === 'S'"><mat-icon>lock</mat-icon></span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="nombre">
          <th id="nombre" mat-header-cell *matHeaderCellDef> Nombre </th>
          <td mat-cell *matCellDef="let emp"> {{emp.nombre | titlecase}} </td>
        </ng-container>
  
        <ng-container matColumnDef="edad">
          <th id="edad" mat-header-cell *matHeaderCellDef> Edad </th>
          <td mat-cell *matCellDef="let emp"> {{emp.edad}} </td>
        </ng-container>
  
        <ng-container matColumnDef="jornada">
          <th id="jornada" mat-header-cell *matHeaderCellDef> Jornada </th>
          <td mat-cell *matCellDef="let emp">
            <span *ngIf="emp.jornada > 0">{{emp.jornada | number:'2.2-2'}} %</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="nivel1">
          <th id="nivel1" mat-header-cell *matHeaderCellDef> Nivel 1 </th>
          <td mat-cell *matCellDef="let emp"> {{emp.nivel1}} </td>
      </ng-container>

      <ng-container matColumnDef="nivel2">
          <th id="nivel2" mat-header-cell *matHeaderCellDef> Nivel 2</th>
          <td mat-cell *matCellDef="let emp"> {{emp.nivel2}} </td>
      </ng-container>

      <ng-container matColumnDef="nivel3">
          <th id="nivel3" mat-header-cell *matHeaderCellDef> Nivel 3</th>
          <td mat-cell *matCellDef="let emp"> {{emp.nivel3}} </td>
      </ng-container>

      <ng-container matColumnDef="nivel4">
          <th id="nivel4" mat-header-cell *matHeaderCellDef> Nivel 4</th>
          <td mat-cell *matCellDef="let emp"> {{emp.nivel4}} </td>
      </ng-container>

      <ng-container matColumnDef="nivel5">
          <th id="nivel5" mat-header-cell *matHeaderCellDef> Nivel 5</th>
          <td mat-cell *matCellDef="let emp"> {{emp.nivel5}} </td>
      </ng-container>
  
        <ng-container matColumnDef="atributos">
          <th id="atributos" mat-header-cell *matHeaderCellDef> Atributos </th>
          <td mat-cell *matCellDef="let emp">
            <span *ngIf="emp.tAttr1 != null && emp.tAttr1 != ''">{{emp.tAttr1 | titlecase}} || </span>
            <span *ngIf="emp.tAttr2 != null && emp.tAttr2 != ''">{{emp.tAttr2 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr3 != null && emp.tAttr3 != ''">{{emp.tAttr3 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr4 != null && emp.tAttr4 != ''">{{emp.tAttr4 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr5 != null && emp.tAttr5 != ''">{{emp.tAttr5 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr6 != null && emp.tAttr6 != ''">{{emp.tAttr6 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr7 != null && emp.tAttr7 != ''">{{emp.tAttr7 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr8 != null && emp.tAttr8 != ''">{{emp.tAttr8 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr9 != null && emp.tAttr9 != ''">{{emp.tAttr9 | titlecase}} ||</span>
            <span *ngIf="emp.tAttr10 != null && emp.tAttr10 != ''">{{emp.tAttr10 | titlecase}} || </span>
            <span *ngIf="emp.tAttr11 != null && emp.tAttr11 != ''">{{emp.tAttr11 | titlecase}} || </span>
            <span *ngIf="emp.tAttr12 != null && emp.tAttr12 != ''">{{emp.tAttr12 | titlecase}} ||</span>
            <span *ngIf="(emp.tAttr1 === null || emp.tAttr1 === '') && 
              (emp.tAttr2 === null || emp.tAttr2 === '') && 
              (emp.tAttr3 === null || emp.tAttr3 === '') &&
              (emp.tAttr4 === null || emp.tAttr4 === '') &&
              (emp.tAttr5 === null || emp.tAttr5 === '') &&
              (emp.tAttr6 === null || emp.tAttr6 === '') &&
              (emp.tAttr7 === null || emp.tAttr7 === '') &&
              (emp.tAttr8 === null || emp.tAttr8 === '') &&
              (emp.tAttr9 === null || emp.tAttr9 === '') &&
              (emp.tAttr10 === null || emp.tAttr10 === '') &&
              (emp.tAttr11 === null || emp.tAttr11 === '') &&
              (emp.tAttr12 === null || emp.tAttr12 === '')">
              Sin Atributos
           
            </span>
          </td>
        </ng-container>
      <ng-container matColumnDef="tAttr1">
          <th id="tAttr1" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[0].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr1 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr2">
          <th id="tAttr2" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[1].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr2 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr3">
          <th id="tAttr3" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[2].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr3 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr4">
          <th id="tAttr4" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[3].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr4 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr5">
          <th id="tAttr5" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[4].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr5 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr6">
          <th id="tAttr6" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[5].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr6 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr7">
          <th id="tAttr7" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[6].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr7 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr8">
          <th id="tAttr8" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[7].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr8 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr9">
          <th id="tAttr9" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[8].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr9 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr10">
          <th id="tAttr10" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[9].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr10 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr11">
          <th id="tAttr11" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[10].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr11 | titlecase}} </td>
      </ng-container>
      <ng-container matColumnDef="tAttr12">
          <th id="tAttr12" class="atr-p-r-3" mat-header-cell *matHeaderCellDef> {{this.attributeList[11].attributoName}} </th>
          <td class="atr-p-r-3" mat-cell *matCellDef="let leave"> {{leave.tAttr12 | titlecase}} </td>
      </ng-container>
  
        <ng-container matColumnDef="alarmasB">
          <th id="alarmasB" mat-header-cell *matHeaderCellDef> &gt; 3 </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('B')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasD">
          <th id="alarmasD" mat-header-cell *matHeaderCellDef> 100 d. </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('D')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasA">
          <th id="alarmasA" mat-header-cell *matHeaderCellDef> 5,5% </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('A')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasJ">
          <th id="alarmasJ" mat-header-cell *matHeaderCellDef> NJ </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('J')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasP">
          <th id="alarmasP" mat-header-cell *matHeaderCellDef> FPA&gt;60 </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('P')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasL">
          <th id="alarmasL" mat-header-cell *matHeaderCellDef> Mot.Lab </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('L')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasR">
          <th id="alarmasR" mat-header-cell *matHeaderCellDef> No pres </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('R')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasS">
          <th id="alarmasS" mat-header-cell *matHeaderCellDef> Aus Act </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('S')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasU">
          <th id="alarmasU" mat-header-cell *matHeaderCellDef> Aus 12 </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('U')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasI">
          <th id="alarmasI" mat-header-cell *matHeaderCellDef> I.P. </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('I')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
        <ng-container matColumnDef="alarmasK">
          <th id="alarmasK" mat-header-cell *matHeaderCellDef> Insp. </th>
          <td mat-cell *matCellDef="let emp">
            <mat-icon *ngIf="emp.alarmas != null && emp.alarmas.includes('K')"
              class="mat-icon material-icons mat-icon-no-color except" role="img" aria-hidden="true">
              check </mat-icon>
          </td>
        </ng-container>
  
  
        <ng-container matColumnDef="absentismo">
          <th id="absentismo" mat-header-cell *matHeaderCellDef> % Abs </th>
          <td mat-cell *matCellDef="let emp">
            <span *ngIf="emp.absentismo > 0">{{emp.absentismo | number:'2.2-2'}}  %</span>
          </td>
        </ng-container>
  
        <ng-container matColumnDef="bradford">
          <th id="bradford" mat-header-cell *matHeaderCellDef> Bradford </th>
          <td mat-cell *matCellDef="let emp"> {{emp.bradford}} </td>
        </ng-container>
  
        <ng-container matColumnDef="aviso">
          <th id="aviso" mat-header-cell *matHeaderCellDef> Aviso </th>
          <td mat-cell *matCellDef="let emp"> {{emp.aviso}} </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="getDisplayedColumns(); sticky: true"></tr>
        <tr mat-row *matRowDef="let emp; columns: getDisplayedColumns();" 
          [ngClass]="{'selection-highlight-row': selectedRowIndex == emp.trabajadorId && selectionService.isShowLeavePanel}"
          (click)="getLeaveRecord(emp, $event)">
        </tr>
      </table>
    </div>
  </div>
</div>